import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';
import { createService, createModule } from '@/models/core';

const configuration = {
  name: 'owner',
  type: 'node--owner',
  attributes: {
    uuid: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'uuid',
    },
    apellidos: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'apellidos_owner',
    },
    dni: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'dni',
    },
    nombre: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'nombre',
    },
  },
  relationships: {},
};

export const OwnerService = createService(base, configuration, API_CONFIG.API);

export const OwnerModule = createModule(OwnerService, true);




// WEBPACK FOOTER //
// ./src/models/owner.js